import React from 'react'
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  CardActions
} from '@material-ui/core'
import { useModuleStyles } from './modules.styles'

const Cards = ({ title, Icon, onClick }) => {
  const classes = useModuleStyles()

  return (
    <Card className={classes.card} onClick={onClick}>
      <CardContent className={classes.content}>
        <Grid item className={classes.icon}>
          {Icon && <Icon />}
        </Grid>
        <Typography className={classes.title} variant="h6" component="h2">
          {title}
        </Typography>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button size="small" color="outlined">
          Создать заявку
        </Button>
      </CardActions>
    </Card>
  )
}

const ModulesCards = ({ modules, handleOpen }) => {
  const classes = useModuleStyles()

  return (
    <div className={classes.root}>
      <Grid container spacing={4}>
        {modules.map((item, idx) => {
          const gridSize = [
            'AsterX',
            'Доступы',
            'Запрос на технику',
            'Сеть и интернет',
            'Сотовая связь',
            '1С',
            'Видеонаблюдение',
            'Прочее'
          ].includes(item.module)
            ? 6
            : 12
          return (
            <Grid item xs={gridSize} sm={6} md={3} lg={3} key={`module_${idx}`}>
              <Cards
                title={item.module}
                Icon={item.icon}
                onClick={() => handleOpen(item)}
              />
            </Grid>
          )
        })}
      </Grid>
    </div>
  )
}

export default ModulesCards
